import { PermissionT } from "../types";

export const financeManagement = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "finance_management");
  return !!p;
};

export default financeManagement;
